import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "@mdx-js/react";
export const frontmatter = {
  "title": "التمويل",
  "lead": "لم تحقق دولة من بين كل ثلاث دول أيًا من معايير التمويل المحددة في إطار العمل الخاص بالتعليم حتى عام 2030."
};
function _createMdxContent(props) {
  const _components = {
    a: "a",
    blockquote: "blockquote",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  }, {Figure, HighlightByIndex, HighlightByPalette, IndicatorReference, RelatedMaterial, ScrollyArea, ScrollySection, ScrollySticky} = _components;
  if (!Figure) _missingMdxReference("Figure", true);
  if (!HighlightByIndex) _missingMdxReference("HighlightByIndex", true);
  if (!HighlightByPalette) _missingMdxReference("HighlightByPalette", true);
  if (!IndicatorReference) _missingMdxReference("IndicatorReference", true);
  if (!RelatedMaterial) _missingMdxReference("RelatedMaterial", true);
  if (!ScrollyArea) _missingMdxReference("ScrollyArea", true);
  if (!ScrollySection) _missingMdxReference("ScrollySection", true);
  if (!ScrollySticky) _missingMdxReference("ScrollySticky", true);
  return _jsxs(_Fragment, {
    children: [_jsx(Figure, {
      id: "HERO_FINANCE"
    }), "\n", _jsxs(_components.blockquote, {
      children: ["\n", _jsx(_components.p, {
        children: "لن تتحقق أهداف التنمية المستدامة الطموحة المتعلقة بالتعليم دون موارد إضافية، خصوصًا في البلدان الأكثر تخلفًا عن الركب."
      }), "\n"]
    }), "\n", _jsx(_components.p, {
      children: "يُقدر التقرير العالمي لرصد التعليم أنه من أجل تحقيق هدف تعميم التعليم الأساسي بحلول عام 2030، أي التعليم ما قبل الابتدائي والابتدائي والثانوي، يجب على البلدان المنخفضة الدخول والمتوسطة الدخول من الشريحة الدنيا إنفاق 461 مليار دولار أمريكي سنويًا. ومن غير المرجح أن تتمكن العديد من البلدان من زيادة ميزانياتها بشكل كافٍ؛ بسبب انخفاض الإيرادات الضريبية، مما يؤدي إلى فجوة تمويلية سنوية تُقدر بنحو 97 مليار دولار أمريكي (21% من التكلفة الإجمالية)؛ لتحقيق الأهداف الوطنية بين عامَي 2023 و2030. ويبلغ متوسط الفجوة 26 مليار دولار أمريكي (50% من الإجمالي) في البلدان المنخفضة الدخول و71 مليار دولار أمريكي (17%) في البلدان المتوسطة الدخول من الشريحة الدنيا، وهو ما يعادل 2.3% من الناتج المحلي الإجمالي خلال هذه الفترة."
    }), "\n", _jsx(IndicatorReference, {
      id: "4.5.3",
      children: _jsxs(_components.p, {
        children: ["مع ذلك، إن امتلاك المزيد من الموارد ليس كافيًا بالضرورة؛ فالبلدان التي تنفق المبلغ نفسه من حيث نصيب الفرد من الدخل قد تحقق نتائج تعليمية مختلفة بشكل كبير، وذلك يعتمد على مدى فعالية وكفاءة وعدالة الإنفاق. على سبيل المثال، من بين 78 بلدًا منخفض ومتوسط الدخل تتوفر عنه معلومات، حافظ 17 بلدًا فقط - أو بلد من كل خمسة بلدان - على تركيز قوي ", _jsx(_components.a, {
          href: "https://www.unesco.org/gem-report/en/node/80",
          children: "على العدالة من خلال سياسات التمويل"
        }), ". وكانت هذه البلدان في أغلبها من البلدان المتوسطة الدخول من الشريحة العليا من أمريكا اللاتينية."]
      })
    }), "\n", _jsxs(_components.p, {
      children: ["تتمثل المصادر الرئيسية الثلاثة للإنفاق على التعليم في الحكومات والأسر والجهات المانحة. ستركز هذه الصفحة على المصدرين الأولين. توجد صفحة منفصلة مخصصة لـ ", _jsx(_components.a, {
        href: "https://www.education-progress.org/en/articles/finance-aid",
        children: "aid to education"
      }), "."]
    }), "\n", _jsxs(ScrollyArea, {
      children: [_jsx(ScrollySticky, {
        children: _jsx(Figure, {
          id: "TOTBYSOURCE"
        })
      }), _jsx(ScrollySection, {
        id: "absolute,0",
        children: _jsx(_components.p, {
          children: "في عام 2022، من إجمالي 5.8 تريليون دولار أمريكي تم إنفاقها على التعليم في جميع أنحاء العالم، تم إنفاق 0.45% فقط في البلدان المنخفضة الدخول، في حين تم إنفاق 64% في البلدان المرتفعة الدخول، رغم أن عدد الأطفال في سن المدرسة متساوٍ تقريبًا في المجموعتين."
        })
      }), _jsx(ScrollySection, {
        id: "relative,1",
        children: _jsxs(_components.p, {
          children: ["في الدولة المتوسطة، ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "1",
            children: "تتحمل الأسر"
          }), " ربع تكلفة التعليم. في الواقع، تتحمل الأسر جزءًا أكبر بكثير من نفقات التعليم في البلدان المتوسطة الدخول من الشريحة الدنيا (44%)، مقارنةً بالبلدان المرتفعة الدخول (20%)."]
        })
      }), _jsx(ScrollySection, {
        id: "relative,2",
        children: _jsxs(_components.p, {
          children: ["على الرغم من أن ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "الجهات المانحة"
          }), " تساهم بنسبة 12% من إجمالي الإنفاق على التعليم في البلدان المنخفضة الدخول …"]
        })
      }), _jsx(ScrollySection, {
        id: "absolute,3",
        children: _jsxs(_components.p, {
          children: ["… ", _jsx(HighlightByPalette, {
            palette: "06",
            index: "8",
            children: "تشكل مساهمات"
          }), " الجهات المانحة 0.3% فقط من إجمالي الإنفاق العالمي، وهو يكاد يكون غير ملحوظ بالمبالغ المطلقة."]
        })
      })]
    }), "\n", _jsx(_components.h2, {
      id: "النفقات-العامة",
      children: "النفقات العامة"
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.1",
      children: [_jsx(_components.p, {
        children: "لقد وضع [إطار العمل الخاص بالتعليم حتى عام 2030] (https://unesdoc.unesco.org/ark:/48223/pf0000245656) معيارين رئيسيين للتمويل للحكومات. ويدعوها إلى:"
      }), _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: "تخصيص ما لا يقل عن 4% إلى 6% من الناتج المحلي الإجمالي للتعليم، و/أو"
        }), "\n", _jsx(_components.li, {
          children: "تخصيص ما لا يقل عن 15% إلى 20% من الإنفاق العام للتعليم."
        }), "\n"]
      }), _jsx(_components.p, {
        children: "على الصعيد العالمي، لم تبتعد الحكومات كثيرًا عن هذه القواعد. يبلغ متوسط الإنفاق الحكومي 4% من الناتج المحلي الإجمالي و12.6% من إجمالي الإنفاق العام. وعادةً ما تميل الحكومات في البلدان الأكثر فقرًا، التي تعاني من قدرة منخفضة على توليد الموارد المحلية، ولكنها تضم فئات كبيرة من الأطفال إلى تخصيص مبالغ أقل للتعليم كنسبة من الناتج المحلي الإجمالي، ولكنها تكون نسبة أكبر من إجمالي الإنفاق الحكومي."
      })]
    }), "\n", _jsxs(IndicatorReference, {
      id: "F.2",
      children: [_jsx(_components.p, {
        children: "في منطقة أفريقيا جنوب الصحراء الكبرى، يمثل الإنفاق الحكومي على التعليم 15.5% من إجمالي الإنفاق العام، لكنه يمثل 3.5% من الناتج المحلي الإجمالي. وعلى العكس من ذلك، تلبي أوروبا وأمريكا الشمالية المعيار كنسبة من إجمالي الناتج المحلي (4.8%)، ولكنها تخصص حصة منخفضة من إجمالي الإنفاق للتعليم (10.9%)."
      }), _jsx(_components.p, {
        children: "ولكن في المجمل، لم تستوفِ دولة واحدة من كل ثلاث دول تتوفر عنها بيانات حديثة أيًا من المعيارين. استعرض هذه البيانات على مدار الزمن لمعرفة كيفية تغير الإنفاق على مر السنين."
      })]
    }), "\n", _jsx(Figure, {
      id: "GOVVGDP"
    }), "\n", _jsx(_components.p, {
      children: "تشكل الضرائب المصدر الرئيسي لإيرادات الحكومات، حتى في البلدان المنخفضة الدخول التي تحصل على نسبة كبيرة من دخلها من المنح (أي المعونات). وبشكل عام، بلغ متوسط الإيرادات الضريبية نسبة 14% من إجمالي الناتج المحلي في البلدان المنخفضة الدخول، و18% في البلدان المتوسطة الدخول من الشريحة الدنيا، و22% في البلدان المتوسطة الدخول من الشريحة العليا، و33% في البلدان المرتفعة الدخول. على سبيل المثال، حتى إذا منحت جميع البلدان الأولوية نفسها للتعليم في ميزانياتها، فإن البلدان التي تجمع ضرائب وموارد محلية أخرى أكثر ستتمكن من إنفاق المزيد على التعليم."
    }), "\n", _jsx(_components.p, {
      children: "ومع ذلك، فإن التفاوت الكبير في حجم الإنفاق على التعليم بين البلدان ذات الخصائص المتشابهة يشير إلى أنه لا يوجد شيء محدد مسبقًا في هذه العلاقات. تختار بعض البلدان إنفاق قدر أكبر على التعليم لتحقيق أهدافها. ويجب أن نسلط الضوء على البلدان التي لا تقوم بذلك."
    }), "\n", _jsx(_components.h2, {
      id: "نفقات-الأسر",
      children: "نفقات الأسر"
    }), "\n", _jsx(_components.p, {
      children: "تنفق الأسر مبالغ طائلة لدعم تعليم أطفالها - ويكون هذا الإنفاق أكبر في الدول الفقيرة مقارنةً بالدول الغنية."
    }), "\n", _jsx(_components.p, {
      children: "يمكن أن يكون هذا الإنفاق في شكل رسوم دراسية ورسوم أخرى، ولكنه قد يشمل أيضًا شراء سلع وخدمات تعليمية، بعضها ضروري (مثل الكتب المدرسية) والبعض الآخر غير ضروري (مثل الدروس الخصوصية)."
    }), "\n", _jsxs(IndicatorReference, {
      id: "4.5.4",
      children: [_jsx(_components.p, {
        children: "عندما يتم توحيد هذه البيانات عبر البلدان، تتضح أدلة مذهلة على مساهمة الأسر في إجمالي الإنفاق على التعليم. ويمكن لهذا أن يؤدي إلى تغيير طريقة فهمنا للجهود التي تبذلها البلدان في مجال التعليم."
      }), _jsx(_components.p, {
        children: "في البلدان المنخفضة الدخول، تنفق الأسر أقل من 1% من ميزانياتها على التعليم؛ بسبب الصعوبات الاقتصادية. وعلى النقيض من ذلك، تخصص الأسر في البلدان المتوسطة الدخول من الشريحة الدنيا متوسطًا قدره 2.9% ومتوسطًا غير مرجح قدره 3.6% من إنفاقها على التعليم؛ إذ يُعد توزيع إنفاقها هو الأكثر تفاوتًا بين جميع فئات أصحاب الدخول. ويشير ارتفاع مستوى الإنفاق في البلدان المتوسطة الدخول من الشريحة الدنيا إلى أن الأسر تواجه ضغوطًا لتعويض النقص في التمويل العام. وفي البلدان المتوسطة الدخول من الشريحة العليا، ينخفض متوسط الحصة المخصصة للتعليم من ميزانيات الأسر إلى 1.5%، مع متوسط غير مرجح قدره 2.3%. وأخيرًا، تخصص الأسر في البلدان المرتفعة الدخول متوسطًا قدره 1.3% أو متوسطًا غير مرجح قدره 1.7% للتعليم."
      }), _jsxs(ScrollyArea, {
        children: [_jsx(ScrollySticky, {
          children: _jsx(Figure, {
            id: "GOVHH_ABS_REL"
          })
        }), _jsx(ScrollySection, {
          id: "absolute,BGD,FRA",
          children: _jsxs(_components.p, {
            children: ["على سبيل المثال، في عام 2019، كانت ", _jsx(_components.strong, {
              children: "بنغلاديش"
            }), " من بين الدول التي لديها أدنى مستويات ", _jsx(HighlightByIndex, {
              index: "0",
              children: "الإنفاق الحكومي"
            }), " كنسبة مئوية من الناتج المحلي الإجمالي. ولكن عند الأخذ في الاعتبار ", _jsx(HighlightByIndex, {
              index: "1",
              children: "مساهمات الأسر،"
            }), " كان إجمالي الإنفاق الوطني على التعليم كنسبة من الناتج المحلي الإجمالي في بنغلاديش مشابهًا لنظيره في ", _jsx(_components.strong, {
              children: "فرنسا"
            }), "."]
          })
        }), _jsx(ScrollySection, {
          id: "absolute,IND,BEL",
          children: _jsxs(_components.p, {
            children: ["أنفقت حكومة الهند على التعليم ما يقل بنحو 2.4 ", _jsx(HighlightByIndex, {
              index: "0",
              children: "نقطة مئوية من الناتج المحلي الإجمالي"
            }), " مقارنة ", _jsx(_components.strong, {
              children: "ببلجيكا"
            }), " – الشريط الأزرق –، ولكن الهند تجاوزت بلجيكا في إجمالي الإنفاق على التعليم؛ لأن ", _jsx(HighlightByIndex, {
              index: "1",
              children: "الأسر"
            }), " لديها أنفقت أكثر من 2.6 نقطة مئوية من الناتج المحلي الإجمالي على التعليم – الشريط الأحمر."]
          })
        }), _jsx(ScrollySection, {
          id: "relative,NGA,LBN,HTI",
          children: _jsxs(_components.p, {
            children: ["ترتفع ", _jsx(HighlightByIndex, {
              index: "1",
              children: "حصة الأسر"
            }), " من إجمالي الإنفاق على التعليم إلى أكثر من 70% في بعض الدول، مثل ", _jsx(_components.strong, {
              children: "نيجيريا"
            }), " ", _jsx(_components.strong, {
              children: "وهايتي"
            }), " ", _jsx(_components.strong, {
              children: "ولبنان"
            }), "."]
          })
        })]
      })]
    }), "\n", _jsx(_components.h2, {
      id: "خاتمة",
      children: "خاتمة"
    }), "\n", _jsx(_components.p, {
      children: "لطالما زعم الفريق المعني بالتقرير العالمي لرصد التعليم أن فهم الإنفاق على التعليم عالميًا يتطلب دراسة مشتركة للمصادر الثلاثة الرئيسية لتمويل التعليم: التمويل العام المحلي، والتمويل العام الخارجي، والتمويل الخاص. وثمة حاجة إلى بيانات متسقة في الوقت المناسب من البلدان المنخفضة والمتوسطة الدخول بشأن حجم الإنفاق على التعليم ومصادر هذا الإنفاق."
    }), "\n", _jsx(_components.p, {
      children: "بالإضافة إلى زيادة التمويل المتاح للتعليم، فإننا بحاجة أيضًا إلى تعزيز التوزيع العادل. ومن أجل تحقيق الهدف العالمي المتعلق بالتعليم، الهدف الرابع من أهداف التنمية المستدامة، من الأهمية بمكان أن تتحمل البلدان والجهات المانحة المسؤولية وتفي بالتزاماتها."
    }), "\n", _jsx(RelatedMaterial, {
      children: _jsxs(_components.ul, {
        children: ["\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/node/3141",
            children: "COVID-19 is a Serious Threat to Aid to Education Recovery (جائحة كوفيد-19 تشكل تهديدًا خطيرًا للمساعدة في تعافي التعليم)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/financing-for-equity",
            children: "Unlocking Financing for Equity in Education (فتح آفاق التمويل من أجل تحقيق العدالة في التعليم)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://education-profiles.org/",
            children: "Profiles Enhancing Education Reviews (PEER) (الملامح البارزة لتعزيز مراجعات التعليم)"
          })
        }), "\n", _jsx(_components.li, {
          children: _jsx(_components.a, {
            href: "https://en.unesco.org/gem-report/node/3141",
            children: "COVID-19 is a Serious Threat to Aid to Education Recovery (جائحة كوفيد-19 تشكل تهديدًا خطيرًا للمساعدة في تعافي التعليم)"
          })
        }), "\n"]
      })
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
function _missingMdxReference(id, component) {
  throw new Error("Expected " + (component ? "component" : "object") + " `" + id + "` to be defined: you likely forgot to import, pass, or provide it.");
}
